// components/receptionist/ViewAppointmentModal.jsx
import React from "react";

const ViewAppointmentModal = ({ show, onHide, appointment, onPrint, getStatusBadge }) => {
  if (!show || !appointment) return null;
  // Convert time to 12-hour format
const formatTime12Hour = (time24) => {
  if (!time24) return "Pending";
  const [hours, minutes] = time24.split(":");
  const hour = parseInt(hours, 10);
  const ampm = hour >= 12 ? "PM" : "AM";
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};

  return (
    <div className="modal show d-block" style={{ background: "rgba(0,0,0,0.5)" }}>
      <div className="modal-dialog modal-dialog-centered modal-lg">
        <div className="modal-content" style={{ borderRadius: "16px", border: "none" }}>
          <div
            className="modal-header"
            style={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <h5 className="modal-title fw-bold">Appointment Details</h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="row">
              {/* Patient Information */}
              <div className="col-md-6 mb-3">
                <h6 className="text-muted small">PATIENT INFORMATION</h6>
                <div className="border rounded p-3" style={{ background: "#f8f9fa" }}>
                  <p className="mb-2">
                    <strong>Name:</strong> {appointment.pName}
                  </p>
                  <p className="mb-2">
                    <strong>MR-Code:</strong>{" "}
                    <span className="text-primary">{appointment.mrCode}</span>
                  </p>
                  <p className="mb-2">
                    <strong>Father's Name:</strong> {appointment.fatherName || "-"}
                  </p>
                  <p className="mb-2">
                    <strong>Age:</strong> {appointment.age || "-"}
                  </p>
                  <p className="mb-2">
                    <strong>Contact:</strong> {appointment.contact || "-"}
                  </p>
                  <p className="mb-0">
                    <strong>Address:</strong> {appointment.address || "-"}
                  </p>
                </div>
              </div>

              {/* Appointment Details */}
              <div className="col-md-6 mb-3">
                <h6 className="text-muted small">APPOINTMENT DETAILS</h6>
                <div className="border rounded p-3" style={{ background: "#f8f9fa" }}>
                  <p className="mb-2">
                    <strong>Appointment #:</strong>{" "}
                    <span className="badge bg-secondary">
                      {appointment.appointmentNumber || "TBD"}
                    </span>
                  </p>
                  <p className="mb-2">
                    <strong>Department:</strong> {appointment.department}
                  </p>
                  <p className="mb-2">
                    <strong>Doctor:</strong>{" "}
                    {appointment.doctor ? `Dr. ${appointment.doctor.name}` : "Not Assigned"}
                  </p>
                  <p className="mb-2">
                    <strong>Date:</strong> {appointment.date || "Pending"}
                  </p>
                  <p className="mb-2">
                    <strong>Time:</strong> {formatTime12Hour(appointment.time) || "Pending"}
                  </p>
                  {appointment.priority && (
                    <p className="mb-2">
                      <strong>Priority:</strong>{" "}
                      <span className="badge bg-info">{appointment.priority}</span>
                    </p>
                  )}
                  <p className="mb-0">
                    <strong>Status:</strong>{" "}
                    <span
                      className="badge"
                      style={{
                        background: getStatusBadge(appointment.status).bg,
                        color: getStatusBadge(appointment.status).text,
                      }}
                    >
                      {appointment.status}
                    </span>
                  </p>
                </div>
              </div>

              {/* Vital Signs */}
              {appointment.vitals &&
                (appointment.vitals.bp ||
                  appointment.vitals.weight ||
                  appointment.vitals.spo2) && (
                  <div className="col-12 mb-3">
                    <h6 className="text-muted small">VITAL SIGNS</h6>
                    <div className="border rounded p-3" style={{ background: "#f8f9fa" }}>
                      <div className="row">
                        {appointment.vitals.bp && (
                          <div className="col-md-4 mb-2">
                            <strong>BP:</strong> {appointment.vitals.bp}
                          </div>
                        )}
                        {appointment.vitals.weight && (
                          <div className="col-md-4 mb-2">
                            <strong>Weight:</strong> {appointment.vitals.weight} kg
                          </div>
                        )}
                        {appointment.vitals.spo2 && (
                          <div className="col-md-4 mb-2">
                            <strong>SPO2:</strong> {appointment.vitals.spo2}%
                          </div>
                        )}
                        {appointment.vitals.temperature && (
                          <div className="col-md-4 mb-2">
                            <strong>Temperature:</strong> {appointment.vitals.temperature}°F
                          </div>
                        )}
                        {appointment.vitals.height && (
                          <div className="col-md-4 mb-2">
                            <strong>Height:</strong> {appointment.vitals.height} cm
                          </div>
                        )}
                        {appointment.vitals.bmi && (
                          <div className="col-md-4 mb-2">
                            <strong>BMI:</strong> {appointment.vitals.bmi}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

              {/* Payment Information */}
              <div className="col-12 mb-3">
                <h6 className="text-muted small">PAYMENT INFORMATION</h6>
                <div className="border rounded p-3" style={{ background: "#f8f9fa" }}>
                  <p className="mb-2">
                    <strong>Amount Paid:</strong> Rs. {appointment.payment?.feePaid || 0}
                  </p>
                  <p className="mb-2">
                    <strong>Payment Status:</strong>{" "}
                    <span
                      className={`badge ${
                        appointment.payment?.status === "paid" ? "bg-success" : "bg-warning"
                      }`}
                    >
                      {appointment.payment?.status || "unpaid"}
                    </span>
                  </p>
                  <p className="mb-0">
                    <strong>Method:</strong> {appointment.payment?.method || "N/A"}
                  </p>
                  {appointment.payment?.receiptId && (
                    <p className="mb-0 mt-2">
                      <strong>Receipt ID:</strong> {appointment.payment.receiptId}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-primary"
              onClick={() => {
                onPrint(appointment);
                onHide();
              }}
              style={{ borderRadius: "10px" }}
            >
              Print Receipt
            </button>
            <button
              className="btn btn-secondary"
              onClick={onHide}
              style={{ borderRadius: "10px" }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewAppointmentModal;